import { SearchBox } from "@quintype/components";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { string, array, func } from "prop-types";

import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import DownloadLinks from "../../../molecules/DownloadLinks";
import SocialLinks from "../../../molecules/SocialLinks";
import { AppLogo } from "../../app-logo";
import { MenuItem } from "../../menu-item";
import NavbarMenu from "../NavbarMenu";
import { getDate } from "../utils";

import "./hamburger-one.m.css";

const DrawForm = ({ children }) => {
  return [
    <label styleName="search-form-label" htmlFor="searchForm" key="1">
      <button aria-label="search-button" type="submit" styleName="search-form-submit" key="2">
        <SvgIconHandler type="search" width="24" height="24" viewBox="0 0 24 24" />
      </button>
      {children}
    </label>,
  ];
};

DrawForm.propTypes = {
  children: func,
};

const HamburgerOne = ({ displayStyle = "", toggleHandler, hamburgerMenu, secondaryMenu }) => {
  const [openTab, setOpenTab] = useState(false);
  const [currentMenuId, setCurrentMenuId] = useState(null);

  const isFocus = useSelector((state) => get(state, ["isFocus"], false));

  const onClickHandler = (id) => {
    if (id === currentMenuId) setCurrentMenuId(null);
    else setCurrentMenuId(id);
    setOpenTab(!openTab);
  };

  useEffect(() => {
    if (!isFocus) {
      document.getElementsByClassName("search-form-input")[0].blur();
    }
  }, []);

  return (
    <div styleName="hamburger-wrapper" style={{ display: displayStyle }}>
      <div styleName="logo-wrapper">
        <div onClick={toggleHandler} styleName="close-icon">
          <SvgIconHandler type="close" width="24" height="24" viewBox="0 0 12 12" />
        </div>
        <AppLogo />
      </div>
      <div styleName="search-form-wrapper">
        <SearchBox
          template={DrawForm}
          inputId="searchForm"
          inputClassName="search-form-input"
          placeholder="Search"
          onSubmitHandler={toggleHandler}
        />
      </div>
      <ul styleName="hamburger-menu-items">
        {hamburgerMenu.length > 0 &&
          hamburgerMenu.map((item, id) => {
            const isCurrentMenu = currentMenuId === id;
            return (
              <li
                styleName="parent-item-wrapper"
                style={{
                  "border-bottom": isCurrentMenu ? "none" : "",
                }}
                key={item.title}
              >
                <div
                  styleName="parent-item"
                  style={{
                    "margin-bottom": isCurrentMenu ? "16px" : "",
                  }}
                >
                  <MenuItem menuStyle="menu-link" item={item} toggleHandler={toggleHandler} />
                  {item.children && item.children.length > 0 && (
                    <div
                      style={{ transform: isCurrentMenu ? "rotate(180deg)" : "" }}
                      onClick={() => onClickHandler(id)}
                      styleName="chevron-wrapper"
                    >
                      <SvgIconHandler
                        className="chevron"
                        type="down-chevron"
                        width="24"
                        height="24"
                        viewBox="0 0 12 12"
                      />
                    </div>
                  )}
                </div>
                <ul style={{ display: isCurrentMenu ? "" : "none" }}>
                  {item.children.map((childItem) => (
                    <li key={childItem.title} styleName="child-menu-items">
                      <MenuItem menuStyle="menu-link" item={childItem} toggleHandler={toggleHandler} />
                    </li>
                  ))}
                </ul>
              </li>
            );
          })}
      </ul>
      <div styleName="bottom-container">
        <div styleName="social-links-container">
          <SocialLinks />
        </div>
        <NavbarMenu menu={secondaryMenu} />
        <div styleName="download-links-wrapper">
          <DownloadLinks />
        </div>
        <div styleName="seperator"></div>
        <div styleName="date-wrapper">{getDate()}</div>
      </div>
    </div>
  );
};

HamburgerOne.propTypes = {
  displayStyle: string,
  toggleHandler: func,
  hamburgerMenu: array,
  secondaryMenu: array,
};

export default HamburgerOne;
